import React, { useState } from "react";
import "./HiddenPanel.scss"

const HiddenPanel = ({ children, button, className }) => {

    const [ showPanel, setShowPanel ] = useState(false)

    const handleShowPanel = () => {
        setShowPanel(!showPanel)
    }

    return (
        <div className={`hidden-panel ${className} ${showPanel ? 'open': ''}`}>
            <div className="hidden-tab" onClick={handleShowPanel}>
                <div className="hidden-tab-button" href="#">
                    <span>{button}</span>
                </div>
            </div>
            {children}
        </div>
    )
}
export default HiddenPanel;
